import Vue from 'vue';
import dropWrapper from '@/components/global/drop-wrapper/index.vue';
import leveragesBody from '@/components/pages/leveragesPage/index.vue';
import translation from '@/assets/rawData/i18n/leveragesPage.json';
import applyPageI18NMessages from '@/vue-utils/i18n';
export default Vue.extend({
    components: {
        dropWrapper,
        leveragesBody
    },
    created() {
        applyPageI18NMessages(this, 'leveragesPage', translation);
    }
});
